// Always returns NUMBER rounded to 2 decimals
export const round2 = (val) => Number(val.toFixed(2));

// Always returns STRING with 2 decimals
export const round2Str = (val) => round2(val).toFixed(2);

// Random with exactly 2 decimals (NUMBER)
export const random = (min, max) =>
    round2(Math.random() * (max - min) + min);


export const getMinutesPassedToday = () => {
    const now = new Date();
    return now.getHours() * 60 + now.getMinutes();
};

export const getMinutesPassedThisMonth = () => {
    const now = new Date();
    const day = now.getDate(); // 1-based
    const minutesToday = getMinutesPassedToday();
    return (day - 1) * 24 * 60 + minutesToday;
};

export const formatDateTime = (date) => {
    const d = new Date(date);
    return d
        .toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        })
        .replace(",", "");
};

export const getRandomPastDateOfCurrentMonth = () => {
    const now = new Date();

    const year = now.getFullYear();
    const month = now.getMonth(); // 0-based
    const today = now.getDate();

    // pick a past day only (1 → today)
    const day = Math.max(1, Math.floor(Math.random() * today) + 1);

    const date = new Date(year, month, day);

    return date
        .toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        })
        .replace(/\//g, "-");
};